<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="服务网点" prop="nursinghomeId">
            <el-select
              v-model="searchForm.nursinghomeId"
              style="width: 100%"
              placeholder="服务网点"
              @change="nursinghomeIdChange"
            >
              <el-option
                v-for="item in nursinghomeIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="活动人员" prop="elderlyId">
            <el-select clearable v-model="searchForm.elderlyId" style="width: 100%" placeholder="活动人员">
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="主题" prop="theme">
            <el-input
              clearable
              v-model="searchForm.theme"
              placeholder="主题"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>

      <template slot="menuLeft">
        <el-button v-if="permissionList.addBtn" type="primary" size="small" @click="addNursingForm"> 新 增</el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button v-if="permissionList.viewBtn" type="text" size="small" @click="viewFun(scope.row)">查看 </el-button>
        <el-button v-if="permissionList.editBtn" type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>

        <el-button v-if="permissionList.delBtn" type="text" size="small" @click="deleteFun(scope.row.id)">删除 </el-button>
      </template>
    </avue-crud>

    <itemList ref="itemList"></itemList>
    <hr-dialog
      :title="formModel==='add'?'新增':formModel==='edit'?'编辑':'查看'"
      :allowFull="false"
      width="60%"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <activeForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></activeForm>
      </template>
    </hr-dialog>
  </basic-container>
</template>
  <script>
import { getnursinghomeIdList } from '@/api/crmedical/project/project';
import { stockWarnPage, getWarehouseList, stockWarnDelete } from '../api/serveItemManage.js';
import activeForm from './activeForm.vue';
import searchFromShow from '@/components/search-form-show/index';
import { mapGetters } from 'vuex';
import {
  getNursingList,
  getNursinghome,
  getWristbandPage,
  getDeviceTypeList,
  wristbandRemove,
  getEventsPage,
  eventsRemove
} from '../api/serveItemManage';

export default {
  components: { searchFromShow, activeForm },
  data() {
    return {
      editVisible: false,
      formModel: 'add',
      isImportDialogShow: false,
      settingTotalWarnVisible: false,
      nursingFormVisible: false,
      printVisible: false,
      addOrderVisible: false,
      alarmRuleVisible: false,
      alarmRuleTittle: '编辑',
      alarmRuleModel: 'view',
      rowInfo: {},
      searchForm: {
        nursinghomeId: '',
        warehouseId: '',
        type: '0',
        consumableCode: '',
        consumableName: '',
        specification: '',
        upWarnFlag: 'false',
        downWarnFlag: 'false',
      },

      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          // {
          //   label: '服务网点',
          //   prop: 'warehouseName',
          // },
          // {
          //   label: '活动名称',
          //   prop: 'theme',
          // },
          {
            label: '主题',
            prop: 'theme',
          },
          {
            label: '时间',
            prop: 'eventsTime',
          },
          {
            label: '地点',
            prop: 'location',
          },
          {
            label: '活动人员',
            prop: 'elderlyNames',
          },
          {
            label: '描述',
            prop: 'description',
          },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',
      formRow: {},
      nursinghomeIdList: [],
      userList: [],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.activeManage_view, false),
        addBtn: this.vaildData(this.permission.activeManage_add, false),
        editBtn: this.vaildData(this.permission.activeManage_edit, false),
        delBtn: this.vaildData(this.permission.activeManage_del, false),
      };
    },
  },
  mounted() {
    this.calcHeight();
      self.$refs.crud.doLayout();
    window.onresize = () => {
      self.$refs.crud.doLayout();
    }
  },
  activated(){
    console.log('activated=======================');
    this.$refs.crud.doLayout();
  },
  methods: {
    openItemDetail(row) {
      this.$refs.itemList.openItemListOnload(row.id, row.name);
    },
    addNursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },
    importSuccess() {
      this.isImportDialogShow = false;
      this.onLoad();
    },

    deleteFun(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          eventsRemove(id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
viewFun(row){

      this.formModel = 'view';
      this.nursingFormVisible = true;
      this.formRow = row;
      this.editVisible = true;
},
    editRecord(row) {
      this.formModel = 'edit';
      this.nursingFormVisible = true;
      this.formRow = row;
      this.editVisible = true;
    },
    settingTotalWarn() {
      this.formModel = 'add';
      this.settingTotalWarnVisible = true;
    },
    importFun() {
      this.isImportDialogShow = true;
    },
    nursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },

    recordCancle() {
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
    },
    recordSuccess() {
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
      this.onLoad();
    },
    viewRecord(row) {
      this.alarmRuleTittle = '查看';
      this.rowInfo = row;

      this.alarmRuleModel = 'view';
      this.alarmRuleVisible = true;
    },

    addRecord() {
      this.alarmRuleTittle = '新增';
      this.alarmRuleVisible = true;
      this.rowInfo = {
        nursinghomeId: this.searchForm.nursinghomeId,
      };
      this.alarmRuleModel = 'add';
    },

    stopCanteen() {
      this.alarmRuleVisible = true;
    },
    nursinghomeIdChange(nursinghomeId) {
      this.searchForm.warehouseId = '';
      this.warehouseList = [];
      getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
        this.warehouseList = res.data;
      });
      // //  getCanteenName({nursinghomeId:nursinghomeId}).then(res=>{
      // //           this.canteenList = res.data
      // //        })
      // this.getDeptList(this.searchForm.nursinghomeId);
      // this.getCanteen(this.searchForm.nursinghomeId);
    },
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.upWarnFlag == '') {
        this.searchForm.upWarnFlag = false;
      }
      if (this.searchForm.downWarnFlag == '') {
        this.searchForm.downWarnFlag = false;
      }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'nursinghomeId');
      this.searchForm.type = '0';
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    initData() {
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
        if (this.nursinghomeIdList.length > 0) {
          this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);
          // getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
          //   this.warehouseList = res.data;
          // });
          getNursingList({ id: this.searchForm.nursinghomeId }).then((res) => {
            this.userList = res.data;
          });
          this.onLoad();
        }
      });
      // getDictionary('canteen_order_status').then((res) => {
      //   this.orderStatus = res.data;
      // });
    },

    onLoad() {
      if (this.searchForm.nursinghomeId != '') {
        this.loading = true;

        getEventsPage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
  
  <style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
  <style>
#alarmRule > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
  